<template src="./item_form.html"></template>

<script>
import { CreateModule } from '@/api/auth'

export default {
  name: 'add-module',
  data: function () {
    return {
      model: {
        app_id: null,
        parent_item: '',
        item: '',
        type: '',
        route: '',
        note: ''
      },
      types: {
        '1': '前端',
        '2': '后端'
      },
      ruleValidate: {
        item: [{
          required: true,
          message: '必须填写子项名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '必须填写子项类型',
          trigger: 'blur'
        }],
        note: [{
          required: true,
          message: '模块描述或备注不能为空',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    init: function (item) {
      this.model.app_id = item.app_id
      this.model.parent_item = item.item
      console.log(this.model)
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateModule(this.model).then(async res => {
        if (res.error) {
          this.$Message.error(res.error)
        } else {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
